module.exports = __webpack_public_path__ + "img/logo.40d3514c.png";